[
  {
    "id": "chapter:10a",
    "q": "When driving at night and a vehicle comes toward you with their high beam headlights on:",
    "answer": {
      "text": "Flash your headlights once quickly",
      "section": 10,
      "topic": "Night Driving",
      "page": 91
    },
    "otherChoices": ["Keep your high beam headlights on", "Look in the direction of their vehicle"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:10b",
    "q": "When approaching animals that are standing near the roadway:",
    "answer": {
      "text": "Slow down and use caution",
      "section": 10,
      "topic": "Avoiding Collisions with Animals",
      "page": 92
    },
    "otherChoices": ["Speed up to scare them away", "Swerve to avoid the animal"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "sample:7",
    "q": "If you see a flooded roadway ahead:",
    "answer": {
      "text": "Turn around and find another route to get to your destination",
      "section": 10,
      "topic": "Flooded Roadways",
      "page": 91
    },
    "otherChoices": [
      "Check to make sure it is not too deep and then cross carefully",
      "Stop your vehicle on the roadway"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:7:derived:a",
    "q": "If a flooded roadway is ahead and there is no other route to your destination:",
    "answer": {
      "text": "Proceed to higher ground and wait for the waters to subside",
      "section": 10,
      "topic": "Flooded Roadways",
      "page": 91
    },
    "otherChoices": [
      "Cross slowly to keep the engine from stalling",
      "Cross only if the water appears less than six inches deep"
    ],
    "generated": {
      "parent": "sample:7",
      "type": "paired",
      "rationale": "Paired counterpart of sample:7 sourced from the same Flooded Roadways bulleted list on page 91. Where sample:7 covers the default response to a flooded roadway, this variant covers the no-alternate-route case taught in the adjacent bullet: 'If there is no other route, proceed to higher ground and wait for the waters to subside.' The slow-cross distractor inverts the handbook's explicit warning that 'Even if the water appears shallow enough to cross, do not attempt to cross a flooded road.' The six-inch distractor reuses a handbook depth threshold from the same paragraph (six inches reaches the bottom of most passenger cars, causing loss of control or stalling) misapplied as a permission to cross."
    },
    "batch": "review-20260502b",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:12",
    "q": "When driving on gravel or dirt roads, you must:",
    "answer": {
      "text": "Reduce your speed and increase your following distance",
      "section": 10,
      "topic": "Rural Road Driving — Gravel or Dirt",
      "page": 90
    },
    "otherChoices": [
      "Increase your speed and increase your following distance",
      "Reduce your speed and reduce your following distance"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:12:derived:a",
    "q": "When dust on a gravel road reduces your vision, you should:",
    "answer": {
      "text": "Use low beam headlights, slow down and increase your following distance",
      "section": 10,
      "topic": "Rural Road Driving — Dust",
      "page": 90
    },
    "otherChoices": [
      "Use high beam headlights to see further through the dust",
      "Maintain your speed to keep ahead of the dust cloud"
    ],
    "generated": {
      "parent": "sample:12",
      "type": "paired",
      "rationale": "Paired counterpart of sample:12 sourced from the same Rural Road Driving bulleted list on page 90. Where sample:12 covers the gravel or dirt traction response, this variant covers the dust-vision response taught in the adjacent bullet: 'During dry periods of the year, gravel roads can become extremely dusty. Vision can be reduced. It is recommended that you use low beam headlights to make your vehicle more visible to others, slow down and increase your following distance.' The high-beam distractor inverts the handbook's specific guidance to use low beams. The maintain-speed distractor inverts the slow-down rule taught in the same bullet."
    },
    "batch": "review-20260502b",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s10-dim-high-beams-distance",
    "q": "You should dim your high beams whenever you come within about _____ of an oncoming vehicle.",
    "answer": {
      "text": "A one-block distance",
      "section": 10,
      "topic": "Night Driving",
      "page": 91
    },
    "otherChoices": ["50 feet", "A quarter of a mile"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 4,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s10-high-beam-use",
    "q": "To see better at night, use your high beam headlights:",
    "answer": {
      "text": "Whenever there are no oncoming vehicles",
      "section": 10,
      "topic": "Night Driving",
      "page": 90
    },
    "otherChoices": [
      "When following another vehicle, in heavy traffic, in fog, or when it is snowing or raining hard",
      "Whenever you come within about a one-block distance of an oncoming vehicle"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s10-inevitable-animal-collision",
    "q": "If a collision with an animal is inevitable:",
    "answer": {
      "text": "Do not swerve to avoid the animal",
      "section": 10,
      "topic": "Avoiding Collisions with Animals",
      "page": 92
    },
    "otherChoices": ["Flash your headlights to move the animal out of the way", "Brake hard and lock the wheels"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s10-flood-water-depths",
    "q": "When water covers the roadway:",
    "answer": {
      "text": "6 inches can cause loss of control or stalling, and 2 feet of rushing water can carry away most vehicles",
      "section": 10,
      "topic": "Driving in Adverse Weather, Flooded Roadways",
      "page": 91
    },
    "otherChoices": [
      "6 inches of rushing water can carry away most vehicles, and 2 feet can cause loss of control or stalling",
      "Water that appears shallow enough to cross can be crossed slowly"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s10-avoid-animal-with-time",
    "q": "If an animal is on the road ahead and you think you have time to react, you should:",
    "answer": {
      "text": "Reduce your speed, and brake hard without locking the wheels if no vehicles are close behind you",
      "section": 10,
      "topic": "Avoiding Collisions with Animals",
      "page": 92
    },
    "otherChoices": [
      "Flash your headlights at the animal to scare it off the road",
      "Swerve off the roadway around the animal"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 3,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
